// extracted by mini-css-extract-plugin
module.exports = {"ratings-reviews-msg-heading":"ComingSoon_ratings-reviews-msg-heading___NSMh","ratings-reviews-msg-desc":"ComingSoon_ratings-reviews-msg-desc__P_f2S"};